import apiClient from "../../../utilities/apiClient";

export const createNew = (payload) => {
  return apiClient.post(`${apiClient.Urls.create_new}`, payload);
};
